import React from 'react';
import DashboardJuridico from 'components/organisms/dashboard_juridico';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import BlockedSubscription from 'components/molecules/blocked_subscription';

const JuridicoFacil = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return (
    <div className="page-container p-4">
      {profile.paralyzed ? (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      ) : (
        <DashboardJuridico />
      )}
    </div>
  );
};
export default JuridicoFacil;
